import { render, staticRenderFns } from "./ricardo.vue?vue&type=template&id=0f8e92ec&scoped=true"
var script = {}
import style0 from "./ricardo.vue?vue&type=style&index=0&id=0f8e92ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e92ec",
  null
  
)

export default component.exports